
import {ItemsListOptions} from '../models/itemsListOptions';
import {ItemWrapper} from '../models/itemWrapper';

export class ItemsListController implements angular.IController {
    
    static $inject = ['$mdMedia'];

    private _items: Array<any>;
    private _options: ItemsListOptions;
    private _wrappedItems: Array<ItemWrapper>;
    private _scrollToTop: boolean;

    selectedItemChanged: any;
    selectedItem: any;
    searchTerm: any;
    infiniteScrolling: Function;
    onGoToTop: Function;
    isLoadingMore: boolean;
    isLoading: boolean;
    itemIcon: string;
    isLetterIcon: boolean;
    isGlobalSearchAllowed: boolean;
    isSearchAllRequestsButtonVisible: boolean;
    isSearchAllRequestsButtonAllowedForUser: boolean;

    constructor(private _$mdMedia: angular.material.IMedia
       
    ) {
       
    }

    $onInit() { };

    isEnabled(key): boolean {
        
        return true;
    }

    set scrollToTop(value: boolean) {
        this._scrollToTop = value;
        if (this._scrollToTop)
            this.onGoToTop();
    }

    get items(): Array<any> {
        return this._items;
    }

    set items(value: Array<any>) {
        this._items = value;
        this.wrapItems();
    }
    
    get options(): ItemsListOptions {
        return this._options;
    }

    set options(value: ItemsListOptions) {
        this._options = value;
        this.wrapItems();
    }

    get mdListItemClass(): string {

        if (this._options.metaDataProperties.length <= 1)
            return "md-2-line";
        else
            return "md-3-line";
    }

    get wrappedItems(): Array<ItemWrapper> {
        return this._wrappedItems;
    }

    get isBigScreen(): boolean {
        return this._$mdMedia('gt-md');
    }

    get hasItemIcon(): boolean {

        let hasItemIconDefined = false;

        if (this.itemIcon !== undefined && this.itemIcon !== '')
            hasItemIconDefined = true;

        return hasItemIconDefined;
    }

    get hasItemIconProperty(): boolean {
        return this._options !== undefined && this._options.itemIconProperty !== undefined;
    }

    get hasSearchTerm(): boolean {
        return this._options !== undefined && this._options.searchTerm !== undefined;
    }

    get hasRightHeader(): boolean {
        return this._options !== undefined && this._options.itemRightHeaderProperty !== undefined;
    }

    get hasNumberRightHeader(): boolean {
        return this._options !== undefined
            && this._options.isItemRightHeaderNumberProperty !== undefined
            && this._options.isItemRightHeaderNumberProperty;
    }

    get rightHeaderNumberOfDecimals(): number {
        if (this._options !== undefined
            && this._options.itemRightHeaderNumberOfDecimalsProperty !== undefined) {
            return this._options.itemRightHeaderNumberOfDecimalsProperty;
        } else {
            return 0;
        }
    }

    get hasNumberRightHeaderUom(): boolean {
        return this._options !== undefined
            && this._options.itemRightHeaderUomProperty !== undefined;
    }

    selectItem(item: any): void {
       this.selectedItem = item;
    }

    get hasGroupingField(): boolean {
        return !(this._options.groupingProperty === '');
    }
    
    get groups(): Array<string> {
        if (this.hasGroupingField && this._items != null) {
            const groupArray = [];
            for (let i = 0; i < this._items.length; i++) {
                if (groupArray.indexOf(this._items[i][this._options.groupingProperty]) < 0) {
                    groupArray.push(this._items[i][this._options.groupingProperty]);
                }
            }
            return groupArray;
        }
        return new Array<string>('');
    }
    
    private wrapItems(): void {
        this._wrappedItems = [];
        if (angular.isArray(this._items)
            && angular.isObject(this._options))
            this._wrappedItems = this.getWrappedItems();
    }

    private getWrappedItems(): Array<ItemWrapper> {
        const wrappedItems = [];
        for (let i = 0; i < this._items.length; i++)
            wrappedItems.push(new ItemWrapper(this._items[i], this._options, i));
        return wrappedItems;
    }

    public searchAllRequests(): void {
        this.isGlobalSearchAllowed = true;
    }

   

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/itemsList/controllers/itemsListController.ts
 **/